<template>
  <div class="card fullwidth">
    <header class="card-header fixed-title-height tight-vertical-padding">
      <div class="card-header-title">
        <p>{{ title() }}</p>
      </div>
    </header>
    <header class="card-header is-danger">
      <div class="card-header-title zero-padding">
        <router-link :to="{ name: 'view-general-best-practice', params: { generalBestPracticeId: generalBestPractice.sys.id } }" class="button button-square is-primary column is-12 flex-column">
          Megtekintés &nbsp;
          <font-awesome-icon icon="arrow-alt-circle-right"></font-awesome-icon>
        </router-link>
      </div>
    </header>
    <div class="card-content tight-vertical-padding">
      <div class="columns is-vcentered">
        <div class="column is-3">
          <figure class="image">
            <img class="limited" :src="topicIcon.fields.file.url" :alt="topicIcon.fields.title">
          </figure>
        </div>
        <div class="column is-9">
          <p class="subtitle">
            <span v-if="generalBestPracticeCount > 1">{{ generalBestPracticeNumber }}. általános jógyakorlat</span>
            <span v-else>Általános jógyakorlat</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        title: function () {
          let original = this.generalBestPractice.fields.title
          return this.limitString(original, 100)
        }
      }
    },
    methods: {
      /**
       * @param {String} original
       * @param {Number} maxLength
       * @return {String}
       */
      limitString: function (original, maxLength) {
        try {
          if (original.length <= maxLength) {
            return original
          } else {
            /* Trim first */
            let substring = original.substr(0, maxLength)
            /* Watch words */
            return substring.substr(0, Math.min(substring.length, substring.lastIndexOf(' '))) + ' ...'
          }
        } catch (error) {
          return original
        }
      }
    },
    props: [
      'generalBestPracticeNumber',
      'generalBestPracticeCount',
      'generalBestPractice',
      'topicIcon'
    ]
  }
</script>

<style scoped>
  .fixed-title-height {
    height: 150px;
  }

  .flex-column {
    display: flex;
  }

  .limited {
    max-height: 48px;
    max-width: 48px;
  }
  .tight-vertical-padding {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .zero-padding {
    padding: 0;
  }
  .button-square {
    border-radius: 0;
  }
  .fullwidth {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/BestPractice/GeneralBestPracticeSummaryCard.vue